import type { CartLine } from "./types";

const KEY = "majlis:cart:v1";

function safeParse(json: string): CartLine[] {
  try {
    const arr = JSON.parse(json) as unknown;
    if (!Array.isArray(arr)) return [];
    return arr
      .map((x) => ({
        id: Number((x as any)?.id),
        name: String((x as any)?.name ?? ""),
        price: Number((x as any)?.price ?? 0),
        imageUrl: (x as any)?.imageUrl
          ? String((x as any)?.imageUrl)
          : undefined,
        quantity: Math.max(1, Number((x as any)?.quantity ?? 1)),
        selected: Boolean((x as any)?.selected ?? true),
      }))
      .filter((x) => Number.isFinite(x.id) && x.name);
  } catch {
    return [];
  }
}

export function readCart(): CartLine[] {
  if (typeof window === "undefined") return [];
  const raw = window.localStorage.getItem(KEY);
  return raw ? safeParse(raw) : [];
}

export function writeCart(lines: CartLine[]) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(KEY, JSON.stringify(lines));
  window.dispatchEvent(new Event("cartUpdated"));
}

export function clearCart() {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(KEY);
  window.dispatchEvent(new Event("cartUpdated"));
}
